export default class DtoInstallationSituation {
    constructor(obj = {}) {
        this.stationId = obj.stationId // Int,
        this.lastMeasure = obj.lastMeasure // Option[InstallationMeasure],
        this.threshold = obj.threshold // InstallationThreshold,
    }
}